import styled from 'styled-components'

import { Skeleton } from '@blade/ui-kit'

export const TopbarPairItemSkeleton: React.FC = () => {
  return (
    <Root>
      <Currency>
        <Skeleton width={23} height={23} variant="circular" />
        <NetworkSkeleton width={10} height={10} variant="circular" />
      </Currency>
      <Group>
        <SkeletonBar width={43} height={9} />
        <SkeletonBar width={18} height={9} />
        <SkeletonBar width={18} height={9} />
      </Group>
    </Root>
  )
}

const Root = styled.div`
  display: grid;
  grid-template-columns: auto auto;
  gap: 6px;
  align-items: center;
`

const Currency = styled.div`
  display: grid;
  align-items: center;
  justify-content: center;

  position: relative;
`

const Group = styled.div`
  display: grid;
  grid-template-columns: auto auto auto;
  gap: 3px;
`

const NetworkSkeleton = styled(Skeleton)`
  position: absolute;
  bottom: 0;
  right: -2px;

  background: var(--appearance-1);
  border-radius: 50%;
`

const SkeletonBar = styled(Skeleton)`
  > div {
    border-radius: 2px;
  }
`
